import { render } from "./EditMonitor.vue?vue&type=template&id=3d20fb0e&scoped=true"
import script from "./EditMonitor.vue?vue&type=script&lang=js"
export * from "./EditMonitor.vue?vue&type=script&lang=js"

import "./EditMonitor.vue?vue&type=style&index=0&id=3d20fb0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d20fb0e"]])

export default __exports__